// OWNER/ADMIN of an org may pay the enterprise plan self-serve; MEMBER may
// not. The auth backend returns the role lowercased ("admin"/"owner"), so
// normalize before comparing — a raw === against "ADMIN" silently fails and
// leaves the pay CTA disabled for real admins (the bug this guards against).
const ENTERPRISE_MANAGE_ROLES = ['OWNER', 'ADMIN'];

export function canManageEnterprisePlan(role) {
  return ENTERPRISE_MANAGE_ROLES.includes(String(role || '').toUpperCase());
}

// Pure, testable core of the enterprise self-serve checkout.
//
// The backend derives "is a per-org Tilopay plan provisioned?" for us:
// createSubscriptionCheckout returns { success, data: { checkoutUrl } }
// when the org has a plan, or a non-2xx (e.g. 409
// ENTERPRISE_PLAN_NOT_PROVISIONED) when it doesn't. So the flow is:
// try the checkout → redirect to Tilopay on a checkoutUrl, else fall
// back to the contact dialog. Kept framework-free (no window, no React)
// so it unit-tests without mounting the whole view.
//
// Dependencies are injected so the caller (SubscriptionView) wires the
// real BillingService + a redirect and the tests pass fakes.
export async function runEnterpriseCheckout({
  accountId,
  createSubscriptionCheckout,
  clearStalePendingSubscription,
  redirect,
  openContactDialog,
  tier,
}) {
  if (!accountId) return;
  // Best-effort — clears a pending subscription abandoned since mount so
  // it doesn't 409 the fresh checkout.
  await clearStalePendingSubscription();
  const res = await createSubscriptionCheckout(accountId, 'ENTERPRISE');
  if (res && res.success && res.data && res.data.checkoutUrl) {
    redirect(res.data.checkoutUrl);
    return;
  }
  // No provisioned plan (409) or any other non-2xx — fall back to the
  // existing contact dialog, same as non-enterprise tiers degrade.
  openContactDialog('enterprise', tier);
}
